import { useEffect, useState } from "react";
import { WEDDING } from "@/lib/wedding";
import { NAMES } from "@/lib/side";

/**
 * Countdown
 * -----------------------------------------------------------
 * Live days/hours/minutes/seconds to the wedding.
 */
const target = new Date(WEDDING.countdownTarget).getTime();
const CAL_URL =
  `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${NAMES[0]}+%26+${NAMES[1]}+Wedding+%23SonaKaRaj&dates=20261120T053000Z/20261122T053000Z&ctz=Asia/Kolkata&location=Riverarch+Greenfields+Resorts,+Jaipur`;

const pad = (n, len = 2) => String(n).padStart(len, "0");

export default function Countdown() {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const diff = target - now;
  const done = diff <= 0;
  const s = Math.max(0, Math.floor(diff / 1000));
  const units = [
    ["Days", pad(Math.floor(s / 86400), 3)],
    ["Hours", pad(Math.floor((s % 86400) / 3600))],
    ["Minutes", pad(Math.floor((s % 3600) / 60))],
    ["Seconds", pad(s % 60)],
  ];

  return (
    <section
      id="countdown"
      className="relative edge py-28 text-center overflow-hidden"
      style={{ background: "linear-gradient(180deg,#FAF6EE 0%,#F7D9CF 60%,#E8A0BF 100%)" }}
    >
      {/* Faint gold mandala */}
      <svg
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[640px] max-w-none opacity-10 pointer-events-none"
        viewBox="0 0 200 200" fill="none" stroke="#C9A961" strokeWidth="0.6" aria-hidden="true"
      >
        {Array.from({ length: 12 }).map((_, i) => (
          <ellipse key={i} cx="100" cy="55" rx="14" ry="42" transform={`rotate(${i * 30} 100 100)`} />
        ))}
        <circle cx="100" cy="100" r="95" />
        <circle cx="100" cy="100" r="60" />
        <circle cx="100" cy="100" r="20" />
      </svg>

      <div className="relative">
        <div className="overline text-rani mb-5">Save the Date</div>
        <h2 className="font-display text-4xl sm:text-6xl text-rani">
          Countdown to our <em className="italic text-gold-deep">Special Day</em>
        </h2>
        <p className="mt-5 mb-12 font-body text-ink/70">
          Every moment brings us closer to the beginning of our forever.
        </p>

        {done ? (
          <div className="font-display italic text-5xl sm:text-6xl text-rani">Just Married ✦</div>
        ) : (
          <div className="max-w-3xl mx-auto grid grid-cols-2 sm:grid-cols-4 gap-4">
            {units.map(([label, val]) => (
              <div key={label} className="bg-ivory/80 border border-gold/40 rounded-2xl py-6">
                <div className="font-display text-5xl sm:text-6xl text-rani tabular-nums">{val}</div>
                <div className="mt-2 text-[10px] uppercase tracking-chip text-gold-deep">{label}</div>
              </div>
            ))}
          </div>
        )}

        {/* styled like "Special Day" in the heading: italic, gold, same size */}
        <div className="mt-10 font-display italic text-4xl sm:text-6xl text-gold-deep [font-variant-numeric:lining-nums]">
          20-21 <span className="whitespace-nowrap">November 2026</span>
        </div>
        <a
          href={CAL_URL}
          target="_blank"
          rel="noreferrer"
          className="inline-block mt-5 border border-gold-deep text-gold-deep text-xs uppercase tracking-chip px-7 py-3 rounded-full"
        >
          Add to Calendar
        </a>
      </div>
    </section>
  );
}
